/**
 * Identidade do build que ESTÁ RODANDO neste aparelho (rodada 2B1).
 *
 * `__APP_VERSION__` é substituído pelo Vite em tempo de build (`define`), a
 * partir de `APP_VERSION` no ambiente do build (o Dockerfile recebe
 * `ARG APP_RELEASE` de `infra/nv.sh`) ou, fora do Docker, de `git rev-parse`.
 * Ou seja: a string vive DENTRO do bundle. Um bundle antigo servido pelo
 * Service Worker continua declarando o SEU commit mesmo depois de o servidor
 * já estar noutro — é exatamente a distinção que o diagnóstico precisa
 * (foi observado em staging: a PWA instalada rodou o build N-1 até o ciclo
 * de atualização previsto).
 *
 * Nunca consulte o servidor para saber a versão do cliente. O servidor sabe
 * a versão DELE (`x-server-release`, `/health`), e ela fica registrada ao
 * lado, separada.
 */

declare const __APP_VERSION__: string | undefined;

/** Commit completo (ou "dev") embutido neste bundle. */
export const CLIENT_RELEASE: string =
  typeof __APP_VERSION__ === 'string' && __APP_VERSION__.length > 0 ? __APP_VERSION__ : 'dev';

/** Para mostrar: 12 caracteres bastam para achar o commit. */
export function releaseCurta(release: string): string {
  return release.slice(0, 12);
}

export function estaStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  const mm = typeof matchMedia === 'function' ? matchMedia('(display-mode: standalone)').matches : false;
  return mm || (navigator as { standalone?: boolean }).standalone === true;
}

export function controladoPorServiceWorker(): boolean {
  return typeof navigator !== 'undefined' && !!navigator.serviceWorker?.controller;
}
